import { brands } from 'noddi-types';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';
import { isNoddiSupportWidgetEnabled } from './noddiSupportWidget';

/** Whether the current brand has a support chat: Bestdrive's Telia chat or the Noddi support widget. */
export const useHasSupportChat = () => {
  const { currentBrand } = useCurrentBrand();
  return currentBrand === brands.bestdrive || isNoddiSupportWidgetEnabled(currentBrand);
};
